import React from 'react';
import { Helmet } from 'react-helmet-async';

interface TitleProps {
  overwrite?: boolean;
  title: string;
}

const Title = ({ overwrite, title }: TitleProps) => {
  const actual = overwrite ? title : `HOVER Inc - ${title}`;

  return (
    <Helmet>
      <title>{actual}</title>
      <meta content={actual} property="og:title" />
    </Helmet>
  );
};

export { Title };
